<template>
  <form method="post">
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>

          <b-row>
            <b-col sm="12" v-if="errores.length">
              <b-alert show variant="danger">
                <b>Por favor corrige los siguientes errores:</b>
                <ul>
                  <li v-for="(error, index) in errores" :key="index">{{ error }}</li>
                </ul>
              </b-alert>
            </b-col>
          </b-row>

          <form-wizard
            @on-complete="editCustomer()"
            shape="square"
            color="#20a8d8"
            :title="title"
            :subtitle="subtitle"
            :nextButtonText="nextButtonText"
            :backButtonText="backButtonText"
            :finishButtonText="finishButtonText"
          >
            <tab-content title="Información de la cuenta" icon="icon-user">
              <!-- INICIO CONFIGURACIÓN DE LA CUENTA -->
              <b-row>
                <b-col>
                  <b-form-group>
                    <label for="cmbOrigen">Origen</label>
                    <b-form-select
                      v-model="customer.source"
                      class="mb-3"
                      id="cmbOrigen"

                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstSource"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col v-if="customer.source == 32">
                  <b-form-group>
                    <label for="cmbComercial">Comercial</label>
                    <b-form-select
                      v-model="customer.source_staff_id"
                      class="mb-3"
                      id="cmbComercial"

                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstAsesores"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }} {{ item.last_name }} ({{ item.type_name }})</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group>
                    <label for="cmbAvance">Avance</label>
                    <b-form-select
                      v-model="customer.advance"
                      class="mb-3"
                      id="cmbAvance"
                      @change="getAdvanceLevel()"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstAdvance"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group>
                    <label for="cmbNivel">Nivel</label>
                    <b-form-select v-model="customer.advance_level" class="mb-3" id="cmbNivel">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstAdvanceLevel"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbEstado" class="required">Estado</label>
                    <b-form-select
                      v-model="customer.status"
                      class="mb-3"
                      id="cmbEstado"
                      :disabled="role_id != 1 && role_id != 7"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option value="P">Por activar</option>
                      <option value="A">Activo</option>
                      <option value="I">Inactivo</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="txtNombre" class="required">Nombre de la empresa</label>
                    <b-form-input
                      type="text"
                      id="txtNombre"
                      v-model="customer.business_name"
                      ref="inpt"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbTipoPersona">Tipo persona</label>
                    <b-form-select v-model="customer.type" class="mb-3" id="cmbTipoPersona">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstTipoPersona"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbTipoDocumento">Tipo documento</label>
                    <b-form-select
                      v-model="customer.identification_type"
                      class="mb-3"
                      id="cmbTipoDocumento"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstTipoDocumento"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group>
                    <label for="txtIdentificacion" class="required">Identificación</label>
                    <b-form-input
                      type="text"
                      id="txtIdentificacion"
                      placeholder="NIT / CC"
                      v-model="customer.identification"
                      @blur="darDigitoVerificacion"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="1">
                  <b-form-group>
                    <label for="txtDigitoVerificacion">DV</label>
                    <b-form-input
                      type="text"
                      id="txtDigitoVerificacion"
                      v-model="customer.check_digit"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbStaff">Asesor comercial</label>
                    <b-form-select
                      class="mb-3"
                      id="cmbStaff"
                      v-model="customer.staff_id"
                      :disabled="role_id != 1 && role_id != 7"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstAsesores"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }} {{ item.last_name }} ({{ item.type_name }})</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label class="text-warning" for="cmbSmallerAmount">
                      <strong>¿Permite montos minimos?</strong>
                    </label>
                    <b-form-select
                      v-model="customer.smaller_amount"
                      id="cmbSmallerAmount"
                      :disabled="role_id != 1 && role_id != 7"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Seleccione --</option>
                      </template>
                      <option value="S">Si</option>
                      <option value="N">No</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label class="text-warning" for="cmbPrescrita">
                      <strong>¿Permite cartera prescrita?</strong>
                    </label>
                    <b-form-select
                      v-model="customer.pre_written"
                      id="cmbPrescrita"

                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Seleccione --</option>
                      </template>
                      <option value="S">Si</option>
                      <option value="N">No</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group>
                <h5>Información adicional</h5>
              </b-form-group>

              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbIndustria">Industria</label>
                    <b-form-select
                      v-model="customer.industries_id"
                      class="mb-3"
                      id="cmbIndustria"
                      @change="getSubIndustries()"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstIndustries"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="8">
                  <b-form-group>
                    <label for="cmbSubIndustria">Sub industria</label>
                    <b-form-select
                      class="mb-3"
                      id="cmbSubIndustria"
                      v-model="customer.sub_industries_id"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstSubIndustries"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- FIN INFORMACIÓN DE LA CUENTA -->
            </tab-content>

            <tab-content title="Información de contacto" icon="icon-book-open">
              <!-- INICIO INFORMACIÓN DE LA CONTACTO Y UBICACIÓN -->

              <div
                v-for="(itemAddress, index) of customer.lstAddress"
                :key="itemAddress.id"
                :value="itemAddress.id"
                class="container-box"
              >
                <b-form-group>
                  <button
                    class="btn btn-sm btn-danger float-right"
                    type="button"
                    @click="eliminarDireccion(index)"
                    title="Eliminar"
                  >
                    <!-- Eliminar -->
                    <i class="fa fa-trash"></i>
                  </button>
                </b-form-group>

                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="txtDireccion">Dirección</label>
                      <b-form-input type="text" id="txtDireccion" v-model="itemAddress.address"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <label for="txtBarrio">Barrio</label>
                      <b-form-input type="text" id="txtBarrio" v-model="itemAddress.neighborhood"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <label for="cmbDepartamento">Departamento</label>
                      <b-form-select
                        class="mb-3"
                        id="cmbDepartamento"
                        v-model="itemAddress.zone_id"
                        @change="getCitiesByZoneAddress(itemAddress, index, false)"
                      >
                        <template slot="first">
                          <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                        </template>

                        <option
                          v-for="item in itemAddress.lstDepartamento"
                          :key="item.id"
                          :value="item.id"
                        >{{ item.name }}</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="cmbCiudad">Ciudad</label>
                      <b-form-select
                        class="mb-3 cmbCiudad"
                        id="cmbCiudad"
                        v-model="itemAddress.city_id"
                      >
                        <template slot="first">
                          <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                        </template>

                        <option
                          v-for="item in itemAddress.lstCiudad"
                          :key="item.id"
                          :value="item.id"
                        >{{ item.name }}</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <label for="txtLatitud">Latitud</label>
                      <b-form-input type="text" id="txtLatitud" v-model="itemAddress.latitude"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <label for="txtLongitud">Longitud</label>
                      <b-form-input type="text" id="txtLongitud" v-model="itemAddress.longitude"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group>
                      <label for="txtTelefono">Celular</label>
                      <tags-input
                        placeholder="# celular"
                        v-model="itemAddress.lstMobile"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <label for="txtTelefono">Teléfono</label>
                      <tags-input
                        placeholder="# telefono"
                        v-model="itemAddress.lstPhone"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <label for="txtTelefono">Correo electrónico</label>
                      <tags-input
                        placeholder="email.."
                        v-model="itemAddress.lstMail"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <label for="txtSitioWeb">Sitio web</label>
                      <b-form-input type="text" id="txtSitioWeb" v-model="itemAddress.website"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <div class="mb-2">
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  @click="addAddress()"
                >Añadir dirección</button>
              </div>

              <!-- FIN INFORMACIÓN DE LA CONTACTO Y UBICACIÓN -->

              <!-- INICIO INFORMACIÓN DE LA FACTURACION -->

              <b-form-group class="mt-5 mb-0">
                <h5>Información de facturación</h5>
              </b-form-group>

              <b-form-checkbox
                class="mb-2"
                id="checkbox-1"
                v-model="cpInformacionContacto"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                @input="copiarInformacionContacto"
              >Seleccionar información de contacto</b-form-checkbox>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="txtTelefono">Teléfono</label>
                    <b-form-input type="text" id="txtTelefono" v-model="customer.billing_phone"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group
                    validated
                    label="E-mail"
                    label-for="normalEmail"
                    description="Por favor ingrese su correo electrónico."
                  >
                    <b-form-input
                      id="normalEmail"
                      type="email"
                      placeholder="Ingrese su email.."
                      v-model="customer.billing_mail"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="txtDireccionFacturacion">Dirección</label>
                    <b-form-input
                      type="text"
                      id="txtDireccionFacturacion"
                      v-model="customer.billing_address"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="txtBarrioFacturacion">Barrio</label>
                    <b-form-input
                      type="text"
                      id="txtBarrioFacturacion"
                      v-model="customer.billing_neighborhood"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbDepartamentoFacturacion">Departamento</label>
                    <b-form-select
                      class="mb-3"
                      id="cmbDepartamentoFacturacion"
                      v-model="customer.billing_zone_id"
                      @change="cargarCiudadesFacturacion"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstDepartamento"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbCiudadFacturacion">Ciudad</label>
                    <b-form-select
                      class="mb-3"
                      id="cmbCiudadFacturacion"
                      v-model="customer.billing_city"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstCiudadFacturacion"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- FIN INFORMACIÓN DE LA FACTURACION -->
            </tab-content>

            <tab-content title="Contactos" icon="icon-people">
              <!-- INICIO INFORMACIÓN DE CONTACTO -->

              <div
                v-for="(item, index) of customer.lstContacto"
                :key="item.id"
                :value="item.id"
                class="container-box"
              >
                <b-form-group>
                  <button
                    class="btn btn-sm btn-danger float-right"
                    type="button"
                    @click="eliminarContacto(index)"
                    title="Eliminar"
                  >
                    <!-- Eliminar -->
                    <i class="fa fa-trash"></i>
                  </button>
                </b-form-group>

                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-form-input type="text" placeholder="Nombre" v-model="item.name"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <b-form-input type="text" placeholder="Apellido" v-model="item.last_name"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <b-form-input type="text" placeholder="Cargo" v-model="item.occupation"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <b-form-input type="text" placeholder="Correo" v-model="item.mail"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <b-form-input
                        type="date"
                        placeholder="Cumpleaños"
                        v-model="item.birthday_date"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="País Tel."
                        v-model="item.phone_zone"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="Área Tel."
                        v-model="item.phone_area"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="# Teléfono"
                        v-model="item.phone_number"
                        maxlength="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="País Cel."
                        v-model="item.mobile_zone"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="Área Cel."
                        v-model="item.mobile_area"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        placeholder="# Celular"
                        v-model="item.mobile_number"
                        maxlength="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <div class="mb-2">
                <button class="btn btn-sm btn-success" type="button" @click="addContact()">
                  Añadir contacto
                  <!-- <i class="fa fa-plus"></i> -->
                </button>
              </div>

              <!-- FIN INFORMACIÓN DE CONTACTO -->
            </tab-content>

            <tab-content title="Campos personalizados" icon="icon-settings">
              <b-row>
                <c-switch
                  v-model="customer.check_field"
                  class="ml-3 mb-2"
                  color="primary"
                  label
                  variant="pill"
                  v-bind="labelTxt"
                  :size="'lg'"
                />

                <b-col>
                  <b-form-group>
                    <button
                      class="btn btn-sm btn-success"
                      type="button"
                      @click="addCustomField()"
                      :disabled="!customer.check_field"
                    >Añadir campo personalizado</button>
                  </b-form-group>
                </b-col>
              </b-row>

              <div
                v-for="(item, index) of customer.lstCustomFields"
                :key="item.id"
                :value="item.id"
              >
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <b-form-select
                        class="mb-3"
                        v-model="item.type"
                        :disabled="!customer.check_field"
                      >
                        <template slot="first">
                          <option :value="null" disabled>-- Tipo de campo --</option>
                        </template>

                        <option
                          v-for="_item in item.lstType"
                          :key="_item.id"
                          :value="_item.id"
                        >{{ _item.name }}</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        v-model="item.name"
                        :disabled="!customer.check_field"
                        placeholder="Nombre"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        v-model="item.key"
                        :disabled="!customer.check_field"
                        placeholder="Llave"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <button
                        class="btn btn btn-danger"
                        type="button"
                        @click="deleteCustomField(index)"
                        :disabled="!customer.check_field || customer.lstCustomFields.length == 0"
                      >Quitar</button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </tab-content>

            <tab-content title="Finalizar" icon="icon-check">
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="txtObservacion">Descripción o comentarios</label>
                    <b-form-textarea
                      rows="8"
                      id="txtObservacion"
                      no-resize
                      v-model="customer.observation"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </tab-content>
          </form-wizard>
        </b-card>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
export default {
  name: "customerEdit",
  components: {
    cSwitch
  },
  props: {
    caption: {
      type: String,
      default: "EDITAR CUENTA"
    },
    title: {
      type: String,
      default: "Editar Cuenta"
    },
    subtitle: {
      type: String,
      default: "Datos de la cuenta"
    },
    nextButtonText: {
      type: String,
      default: "Siguiente"
    },
    backButtonText: {
      type: String,
      default: "Anterior"
    },
    finishButtonText: {
      type: String,
      default: "Finalizar"
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      lstTipoDocumento: [],
      lstTipoPersona: [],
      lstDepartamento: [],
      lstCiudad: [],
      lstAsesores: [],
      lstCiudadFacturacion: [],
      lstSource: [],
      lstAdvance: [],
      lstAdvanceLevel: [],
      cpInformacionContacto: false,
      customer: {},
      datos: [],
      errores: [],
      loader: null,
      // CIIU
      lstIndustries: [],
      lstSubIndustries: [],
      labelTxt: {
        dataOn: "Si",
        dataOff: "No"
      },
      lstType: []
    };
  },
  beforeMount() {},
  mounted() {
    this.initCustomer();
  },
  computed: {},
  methods: {
    initCustomer() {
      showLoader();
      // this.customer.staff_id = this.role_id == 1 || this.role_id == 7 ? null : auth[0].staff_id;

      // TIPOS DE DOCUMENTO
      this.$http.get(`${this.$urlApi}parameters/2?token=${this.token}`).then(
        response => {
          this.lstTipoDocumento = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      // TIPOS DE PERAONA
      this.$http.get(`${this.$urlApi}parameters/3?token=${this.token}`).then(
        response => {
          this.lstTipoPersona = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      //DEPARTAMENTOS DE COLOMBIA
      this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
        response => {
          this.lstDepartamento = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      //STAFF'S
      //LISTADO DE STAFF'S: 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        response => {
          this.lstAsesores = response.data.data;
          // console.log(response.data.data);
        },
        error => {
          console.log(error);
        }
      );
      // this.$http.get(`${this.$urlApi}staffs?token=${this.token}`).then(
      //   response => {
      //     this.lstAsesores = response.data.data;
      //   },
      //   error => {
      //     console.log(error);
      //   }
      // );

      // 4: AVANCE CLIENTE
      this.$http.get(`${this.$urlApi}parameters/4?token=${this.token}`).then(
        response => {
          this.lstAdvance = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      // 8: ORIGENES DE LA CUENTA
      this.$http.get(`${this.$urlApi}parameters/8?token=${this.token}`).then(
        response => {
          this.lstSource = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      // INSDUSTRIAS
      this.$http.get(`${this.$urlApi}industries?token=${this.token}`).then(
        response => {
          this.lstIndustries = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      //TIPOS DE DATOS PARA LOS CAMPOS PERSONALIZADOS
      this.$http.get(`${this.$urlApi}parameters/13?token=${this.token}`).then(
        response => {
          this.lstType = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      // CARGAR EL CLIENTE O CUENTA CON TODOS SUS DATOS ASOCIADOS
      let id = this.$route.params.id;

      //console.log(`${this.$urlApi}customers/all/${id}?token=${this.token}`)
      this.$http
        .get(`${this.$urlApi}customers/all/${id}?token=${this.token}`)
        .then(
          response => {
            //showLoader()
            this.customer = response.data.data;
            console.log("customers/all/ ---------------------------",response.data.data);
            this.cargarCiudades();
            this.cargarCiudadesFacturacion();
            this.getAdvanceLevel();
            this.getSubIndustries();
            this.cargarTiposCampo();
            this.customer.check_field =
              this.customer.check_field == 1 ? true : false;
            hideLoader();
          },
          error => {
            this.errores = getMsgError(error);
            hideLoader();
          }
        );

      //hideLoader()
    },
    editCustomer() {
      showLoader();
      let id = this.customer.id;
      this.datos = JSON.stringify(this.customer);

      this.$http
        .put(`${this.$urlApi}customers/${id}?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" }
        })
        .then(function(response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Cuenta actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              location.href = `${location.origin}/#/customers`;
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    darDigitoVerificacion() {
      this.customer.check_digit = calcularDigitoVerificacion(
        this.customer.identification
      );
    },
    cargarCiudades() {
      if (this.customer.lstAddress.length > 0) {
        for (var i = 0; i < this.customer.lstAddress.length; i++) {
          var item = this.customer.lstAddress[i];
          //DEPARTAMENTOS DE COLOMBIA
          item.lstDepartamento = this.lstDepartamento;

          if (item.zone_id) {
            this.getCitiesByZoneAddress(item, i, true);
          }
        }
      }
    },
    cargarTiposCampo() {
      if (this.customer.lstCustomFields.length > 0) {
        // console.log(this.lstType);

        for (var i = 0; i < this.customer.lstCustomFields.length; i++) {
          this.customer.lstCustomFields[i].lstType = this.lstType;
        }

        // console.log(this.customer.lstCustomFields);
      }
    },
    cargarCiudadesFacturacion() {
      if (this.customer.billing_zone_id) {
        this.$http
          .get(
            `${this.$urlApi}cities/${this.customer.billing_zone_id}?token=${this.token}`
          )
          .then(
            response => {
              this.lstCiudadFacturacion = response.data.data;
            },
            error => {
              console.log(error);
            }
          );
      }
    },
    copiarInformacionContacto() {
      // debugger;
      if (this.cpInformacionContacto === "true") {
        if (this.customer.lstAddress.length > 0) {
          let item = this.customer.lstAddress[0];
          this.customer.billing_address = item.address;
          this.customer.billing_neighborhood = item.neighborhood;
          this.lstCiudadFacturacion = item.lstCiudad;
          this.customer.billing_zone_id = item.zone_id;
          this.customer.billing_city = item.city_id;
          this.customer.billing_mail = item.lstMail[0].value;
          this.customer.billing_phone = item.lstPhone[0].value;
        }
      } else {
        this.customer.billing_address = null;
        this.customer.billing_neighborhood = null;
        this.customer.billing_city = null;
        this.customer.billing_zone_id = null;
        this.customer.billing_mail = null;
        this.customer.billing_phone = null;
        this.lstCiudadFacturacion = null;
      }
    },
    addContact() {
      let contactoAux = {
        id: null,
        name: null,
        last_name: null,
        occupation: null,
        mail: null,
        phone_number: null,
        phone_zone: null,
        phone_area: null,
        mobile_number: null,
        mobile_zone: null,
        mobile_area: null,
        birthday_date: null
      };

      this.customer.lstContacto.push(contactoAux);
    },
    eliminarContacto(index) {
      this.$delete(this.customer.lstContacto, index);
    },
    addAddress() {
      // -------------------------------------------------------------------------------------------------
      // ATRIBUTOS PARA LA GESTIÓN DE LA DIRECCIÓN
      // -------------------------------------------------------------------------------------------------

      let addressAux = {
        id: null,
        address: null,
        neighborhood: null,
        zone_id: null,
        city_id: null,
        latitude: null,
        longitude: null,
        website: null,
        lstPhone: [],
        lstMobile: [],
        lstMail: [],
        lstDepartamento: [],
        lstCiudad: []
      };
      //DEPARTAMENTOS DE COLOMBIA
      this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
        response => {
          addressAux.lstDepartamento = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      this.customer.lstAddress.push(addressAux);

      console.log(this.customer.lstAddress);

      // -------------------------------------------------------------------------------------------------
      // FIN GESTIÓN DIRECCIÓN
      // -------------------------------------------------------------------------------------------------
    },
    getCitiesByZoneAddress(item, i, start) {
      this.customer.lstAddress[i].lstCiudad = [];

      if (item.zone_id) {
        showLoader();

        this.$http
          .get(`${this.$urlApi}cities/${item.zone_id}?token=${this.token}`)
          .then(
            response => {
              this.customer.lstAddress[i].lstCiudad = response.data.data;
              // console.log(this.debtor.lstAddress[i].lstCiudad);
              if (!start) item.city_id = null;
              $(".cmbCiudad").trigger("change", true);
              $(".cmbCiudad").trigger("change");

              // this.customer.lstAddress[i].lstCiudad = response.data.data;
              // if (!start) item.city_id = null;
              // //item.lstCiudad = response.data.data
              // //console.log(item.lstCiudad)
              // $("#cmbCiudad").trigger("change");
              hideLoader();
            },
            error => {
              console.log(error);
              hideLoader();
            }
          );
      }
    },
    eliminarDireccion(index) {
      this.$delete(this.customer.lstAddress, index);
    },
    getAdvanceLevel() {
      this.$http
        .get(
          `${this.$urlApi}parameters/advance/${this.customer.advance}?token=${this.token}`
        )
        .then(
          response => {
            this.lstAdvanceLevel = response.data.data;
          },
          error => {
            console.log(error);
          }
        );
    },
    getSubIndustries() {
      if (this.customer.industries_id != null) {
        showLoader();
        this.$http
          .get(
            `${this.$urlApi}subindustries/${this.customer.industries_id}?token=${this.token}`
          )
          .then(
            response => {
              this.lstSubIndustries = response.data.data;
              hideLoader();
            },
            error => {
              console.log(error);
              hideLoader;
            }
          );
      }
    },
    addCustomField() {
      // -------------------------------------------------------------------------------------------------
      // ATRIBUTOS PARA GESTIÓN DE CAMPOS PERSONALIZADOS
      // -------------------------------------------------------------------------------------------------

      let field = {
        id: null,
        name: null,
        key: null,
        type: null,
        lstType: []
      };

      //TIPOS DE DATOS PARA LOS CAMPOS PERSONALIZADOS
      this.$http.get(`${this.$urlApi}parameters/13?token=${this.token}`).then(
        response => {
          field.lstType = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      this.customer.lstCustomFields.push(field);
      // -------------------------------------------------------------------------------------------------
      // FIN GESTIÓN CAMPOS PERSONALIZADOS
      // -------------------------------------------------------------------------------------------------
    },
    deleteCustomField(index) {
      this.$delete(this.customer.lstCustomFields, index);
    }
  }
};
</script>
